import React, { useState, useCallback, useMemo } from "react";
import { Form } from "react-bootstrap";

export default React.memo(ChatBox);

function ChatBox(props) {
    const [message, setMessage] = useState("");

    const handleChange = useCallback((e) => {
        setMessage(e.target.value);
    }, []);

    const handleFocus = useCallback(() => {
        props.setIsTextInputFocused(true);
    }, [props.setIsTextInputFocused]);

    const handleBlur = useCallback(() => {
        props.setIsTextInputFocused(false);
    }, [props.setIsTextInputFocused]);

    const handleKeyDown = useCallback((e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (message.trim().length === 0) return;
            props.sendToHistory(message);
            setMessage("");
        }
    }, [message, props.sendToHistory]);

    const style = useMemo(() => ({
        width: `calc(100% - ${props.scrollbarWidth}px)`
    }), [props.scrollbarWidth]);

    return (
        <div
            className="chatbox-wrapper"
            style={style}>
            <Form.Control
                type="text"
                id="chat"
                className='chatbox'
                value={message}
                maxLength={30}
                placeholder="chat..."
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                onChange={handleChange}
            />
        </div>)
}